import React, { useEffect } from 'react';
import {Helmet} from 'react-helmet';
import AboutUs from "../Page/aboutus";
import Faqs from "../Page/faqs";
import Portfolios from "../Page/portfolios";
import Features from "../Page/features";
import Count from "../Page/count";
import Testimonials from "../Page/testimonials";
import Certificate from "../Page/Certificate";
import Contact from "../Page/contact";
{/*import StructuredData from "../Page/StructuredData";*/}


const faqsContent = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Can I design my own website without hiring a web designer?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, it's possible to design your own website using website builders or templates, but it may not always result in a professional and effective website. Hiring a web designer can ensure that your website is visually appealing, functional, and optimized for search engines."
      }
    },
    {
      "@type": "Question",
      "name": "What should I look for in a web designer's portfolio?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Look for their previous work to assess their design style, creativity, and ability to create visually appealing and functional websites. Also, consider the industries they have worked with and the types of websites they have designed."
      }
    },
    {
      "@type": "Question",
      "name": "How important is responsive design for my website?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Responsive design is crucial for modern websites as it ensures your site looks and works well on all devices, including desktops, tablets, and smartphones."
      }
    },
    {
      "@type": "Question",
      "name": "Can I update my website after it's been designed and launched?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, most websites are built with a CMS that allows you to manage and update content. Your web designer can guide you through it."
      }
    },
    {
      "@type": "Question",
      "name": "What should I do if I encounter issues with my website after it's launched?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "You should contact your web designer for support. They can troubleshoot and fix technical issues, provide updates, and ensure smooth performance."
      }
    },
    {
      "@type": "Question",
      "name": "Can a web designer handle website hosting and domain registration?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Some web designers offer hosting and domain registration as part of their service. Confirm this with your designer."
      }
    },
    {
      "@type": "Question",
      "name": "How often should I update my website's design?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Generally, you should refresh your website design every 2-3 years to keep it modern, user-friendly, and competitive."
      }
    },
    {
      "@type": "Question",
      "name": "What are some tips for creating an engaging website?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Use high-quality images and videos, add interactive elements, keep it organized and clear, and regularly update with fresh content."
      }
    },
    {
      "@type": "Question",
      "name": "What are the key qualities of a good web designer?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Creativity, attention to detail, good communication, experience, and ability to understand client needs are key traits of a great web designer."
      }
    },
    {
      "@type": "Question",
      "name": "How much does web design service cost?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "It depends on project complexity, features, and customization. Prices can range from ₹8,000 to ₹90,000. Get quotes before deciding."
      }
    },
    {
      "@type": "Question",
      "name": "What services do web designers offer?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Web designers offer design, development, UX/UI, branding, SEO, content management, and sometimes hosting and e-commerce solutions."
      }
    },
    {
      "@type": "Question",
      "name": "How can I ensure my website is SEO-optimized?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Use SEO-friendly URLs, responsive design, proper meta tags, optimize images, and create high-quality content. Work with a skilled web designer or SEO expert."
      }
    },
    {
      "@type": "Question",
      "name": "What is the difference between front-end and back-end development?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Front-end handles the visual and interactive parts of a website. Back-end manages the database, server, and application logic."
      }
    },
    {
      "@type": "Question",
      "name": "What is a CMS, and why is it important?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "A CMS (Content Management System) allows you to manage website content without coding. It’s essential for easy content updates and site management."
      }
    },
    {
      "@type": "Question",
      "name": "What are the benefits of website testing and optimization tools?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "They help improve performance and user experience by identifying issues, analyzing user behavior, and testing different layouts and features."
      }
    },
    {
      "@type": "Question",
      "name": "Why is responsive design important for websites?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "It ensures your website looks and functions well across all devices. It also helps improve SEO and user engagement."
      }
    }
  ]
};



function App1() {
  return (
   <>
   <Helmet>
 <script type="application/ld+json">
          {JSON.stringify(faqsContent)}
        </script>

<title>Pankaj Kumar Singh | Website Designing Company in Gurgaon</title>
<meta name="description" content="Top Website Designing Company in Gurgaon, Delhi, Noida. Get a modern website design with me in low cost. Elevate your online presence today!"/>
<meta name="keywords" content="Website Designing Company in Gurgaon, website developer in gurgaon, senior website developer, web development company in gurgaon, website maker in gurgaon, website design company, pankaj web designer, pankj, freelance website designer, website designer in gurgaon, website developer near me"/>
<meta property="og:title" content="Pankaj - Website Designing Company in Gurgaon" />
<meta property="og:description" content="Top Website Designing Company in Gurgaon, Delhi, Noida. Get a modern website design with me in low cost. Elevate your online presence today!" />
<meta property="og:url" content="https://www.pankj.com"/>
<meta property="og:image" content="https://www.pankj.com/assets/img/dpnew.jpg"/>
<meta property="og:site_name" content="Pankaj | Website Designing Company in Gurgaon" />
<meta name="twitter:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<meta name="twitter:title" content="Pankaj | Website Designing Company in Gurgaon" />
<meta name="twitter:description" content="Top Website Designing Company in Gurgaon, Delhi, Noida. Get a modern website design with me in low cost. Elevate your online presence today!" />
<link rel="canonical" href="https://www.pankj.com" />
</Helmet>
<section id="hero" className="hero homepg d-flex align-items-center fixedabove">
<video
                className="mainsliderbg"
                autoPlay
                muted
                loop={true} style={{width:'100%'}}>
                <source src="assets/img/pankaj-web-designer1.mp4" type="video/mp4" />
                <source src="bg.ogg" type="video/ogg" />
  </video>
<div className="mainsliderbg">
<div className="container-fluid">
<div className="row">
<div className="col-lg-6 d-flex flex-column">
<img fetchPriority="high" src="../assets/img/thyear.webp" className="homedes" alt="Website Designer" />
<div className="multiple_effects" id="text3d">Website <span></span></div>
<div className="content_sec">
  Looking for a
   <h1 className="headerdesign"> Website Designing Company in Gurgaon</h1>? 
  I am Pankaj Kumar Singh with <b>10+ years</b> of experience in website design, development, and SEO services for businesses across Gurgaon and India.
</div><div data-aos="fade-up" data-aos-delay="600">
<div className="text-center text-lg-start">
<a href="#about" className="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center">
<span>About Me</span>
<i className="bi bi-arrow-right"></i>
</a>
</div>
</div>
{/*
 <div className="waviy">
   <span>Zyuyyuyu</span>
  </div>
 <div className="web_ment_loader">
  <span>W</span>
  <span>e</span>
  <span>b</span>
  <span>ㅤ</span>
  <span>D</span>
  <span>e</span>
  <span>s</span>
  <span>i</span>
  <span>g</span>
  <span>n</span>
  <span>e</span>
  <span>r</span>
</div>
<div id="BrushCursor">
<div className="p p1">Hello World</div>
<div className="p p2">Hello World</div>
<div className="p p3">
Hello World
<div className="cursor"></div>
</div>
</div>
<div className="box_inners">
<div className="inner">
<span>Hello World</span>
</div>
<div className="inner">
<span>Hello World</span>
</div>
</div>
<h2 className="multiple_effects">I am a Web-Developer and <span></span></h2>
<h2 className="multieffecctss">
<span>always be</span>
<div className="message">
    <div className="word1">close</div>
    <div className="word2">code</div>
    <div className="word3">creating</div>
  </div>
</h2>
  <div className="row">
  <div className="col-md-12">
      <span className="title-word title-word-1">This </span>
    <span className="title-word title-word-2">is </span>
    <span className="title-word title-word-3">Pankaj </span>
    <span className="title-word title-word-4">Singh </span>
  </div>
</div>
*/}
</div>
<div className="col-lg-6 hero-img" data-aos="zoom-out" data-aos-delay="200">

<div className="wrapper">
<div className="img-area">
<div className="inner-area">
{/*<img src="../assets/img/pks2.png" alt="Pankaj Singh" />*/}
<div className="bgimg"></div>
</div>
</div>
{/*
<div className="name">Text Name</div>
<div className="buttons">
<button>Message</button>
<button>Subscribe</button>
</div>
<div className="social-share">
<div className="row">
        <i className="far fa-heart"></i>
        <i className="icon-2 fas fa-heart"></i>
        <span>20.4k</span>
      </div>
      <div className="row">
        <i className="far fa-comment"></i>
        <i className="icon-2 fas fa-comment"></i>
        <span>14.3k</span>
      </div>
      <div className="row">
        <i className="fas fa-share"></i>
        <span>12.8k</span>
      </div>
    </div>
*/}
</div>
</div>
</div>
</div> 

</div>
</section>
<main id="main">


 <AboutUs />


<Features />
<Faqs />
<Testimonials/>
<Certificate />
<Contact /> 
</main>
</>
  );
}
export default App1;
